export default {
  namespaced: true,
  state: {
    toasts: [],
  },

  mutations: {
    ADD_TOAST(state, toast) {
      state.toasts.push(toast);
    },
    CLEAR_TOASTS(state) {
      state.toasts = [];
    },
  },

  actions: {
    showToast({ commit }, toast) {
      const defaultToast = { ...toast, life: toast.life || 3000 };
      // The toast object can have keys like: severity, summary, detail, life
      commit('ADD_TOAST', defaultToast);
    },
  },

  getters: {
    toasts: (state) => state.toasts,
  },
};
